
<div><app-spinner [isLoading]="isLoading"></app-spinner>
<div id="schedule_here2" class="dhx_cal_container mt-1" style='width:100%; height:500px;'>
  <div class="dhx_cal_navline">
    <div class="dhx_minical_icon" id="dhx_minical_icon" (click)="show_minical()" >&nbsp;</div>
    <div class="dhx_cal_prev_button">&nbsp;</div>
    <div class="dhx_cal_next_button">&nbsp;</div>
    <div class="dhx_cal_today_button"></div>
    <div class="dhx_cal_date"></div>
    <div class="dhx_cal_tab" name="day_tab" style="right:204px;"></div>
    <div class="dhx_cal_tab" name="week_tab" style="right:140px;"></div>
    <div class="dhx_cal_tab" name="month_tab" style="right:76px;"></div>
  </div>
  <div class="dhx_cal_header"></div>
  <div class="dhx_cal_data"></div>
</div>